import MagneticButton from "@/components/MagneticButton";
import { cn } from "@/lib/utils";

/** Shared solid primary CTA surface — matches existing .cta-solid white pill look. */
const PRIMARY_CTA_CLASSES =
  "cta-solid group inline-flex items-center gap-3 rounded-full bg-white text-sm font-medium text-black";

/**
 * Primary call-to-action: MagneticButton + established solid CTA styling.
 * Pass size/spacing/state utilities via className (e.g. px-7 py-4) without
 * re-declaring the shared visual system.
 */
export default function PrimaryCTA({ className = "", children, ...props }) {
  return (
    <MagneticButton className={cn(PRIMARY_CTA_CLASSES, className)} {...props}>
      {children}
    </MagneticButton>
  );
}
